export default class AgentViewModel {
    public userName: string;
    public payrollNumber: number;
}